class HdtMediaDedupeObserver {
    static init() {
        document.querySelectorAll('hdt-product-media[data-variant-images]').forEach((el) => {
            HdtMediaDedupeObserver.process(el);
        });
    }

    static async process(el) {
        const raw = el.dataset.variantImages;
        if (!raw) return;

        let variantImages;
        try {
            variantImages = JSON.parse(raw);
        } catch (e) {
            return;
        }

        if (!variantImages || variantImages.length < 2) return;

        const cleaned = await window.HDTImageDedupe.dedupeImagesHybrid(variantImages);
        const cleanedSet = new Set(cleaned.map((u) => u.split('?')[0]));

        el.querySelectorAll('img').forEach((img) => {
            const src = (img.currentSrc || img.src || '').split('?')[0];
            const isVariantImg = variantImages.some((v) => v.split('?')[0] === src);
            if (isVariantImg && !cleanedSet.has(src)) {
                img.closest('.hdt-slider__slide')?.setAttribute('hidden', '');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => HdtMediaDedupeObserver.init());
document.addEventListener('shopify:section:load', () => HdtMediaDedupeObserver.init());
